// src/utils/apiErrorHandler.js
import { logoutUserAsync } from "../store/thunks/authThunk";

export const handleApiError = (error, rejectWithValue, dispatch) => {
    if (error.response && error.response.status === 401) {
        dispatch(logoutUserAsync());
    }
    return rejectWithValue(error.response.data || error.message);
};
